import {
  categoryCodeFragment,
  categoryDetailsFragment,
  categoryFragment
} from "@saleor/fragments/categories";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import { fragmentMoney } from "@saleor/fragments/products";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { CatDetails, CatDetailsVariables } from "./types/CatDetails";
import {
  CategoryDetails,
  CategoryDetailsVariables
} from "./types/CategoryDetails";
import { RootCategories } from "./types/RootCategories";

export const rootCategories = gql`
  ${categoryFragment}
  ${pageInfoFragment}
  query RootCategories(
    $first: Int
    $after: String
    $last: Int
    $level: Int
    $levels: [Int]
    $before: String
    $filter: CategoryFilterInput
    $sort: CategorySortingInput
  ) {
    categories(
      first: $first
      after: $after
      last: $last
      level: $level
      levels: $levels
      before: $before
      filter: $filter
      sortBy: $sort
    ) {
      edges {
        node {
          ...CategoryFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useRootCategoriesQuery = makeQuery<RootCategories, {}>(
  rootCategories
);

export const categoryDetails = gql`
  ${fragmentMoney}
  ${categoryFragment}
  ${categoryDetailsFragment}
  ${pageInfoFragment}
  query CategoryDetails(
    $id: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    category(id: $id) {
      ...CategoryDetailsFragment
      children(first: $first, after: $after, last: $last, before: $before) {
        edges {
          node {
            ...CategoryFragment
          }
        }
        pageInfo {
          ...PageInfoFragment
        }
      }
      deeplinkUrl
      shortDynamicLink
      isFeatured
      products(first: $first, after: $after, last: $last, before: $before) {
        pageInfo {
          ...PageInfoFragment
        }
        edges {
          cursor
          node {
            id
            name
            isAvailable
            thumbnail {
              url
            }
            productType {
              id
              name
            }
            pricing {
              priceRangeUndiscounted {
                start {
                  gross {
                    ...Money
                  }
                }
                stop {
                  gross {
                    ...Money
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const useCategoryDetailsQuery = makeQuery<
  CategoryDetails,
  CategoryDetailsVariables
>(categoryDetails);

export const getCategoryParents = gql`
  query CategoryParentDetails($id: ID!) {
    category(id: $id) {
      id
      name
      code
      parent {
        id
        name
        code
      }
    }
  }
`;

export const getCategory = gql`
  ${categoryCodeFragment}
  query CatDetails($id: ID!) {
    category(id: $id) {
      ...CategoryCodeFragment
    }
  }
`;

export const useCatDetailsQuery = makeQuery<CatDetails, CatDetailsVariables>(
  getCategory
);
